<script lang="ts">
	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';
	import { format } from 'svelte-i18n';
	import { Button } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import MainStep from 'src/components/Devices/DeviceWizard/AddEditSteps/MainStep.svelte';
	import { devices } from 'src/stores/lists/devices';
	import { performDeviceEditSave } from 'src/helpers/edit_device_save_helper';
	import type { Device } from 'src/types/Device';

	export let device: Device;

	let editDevice: Device = device;
	let requestLoader = false;

	$: if (device && editDevice?.id !== device?.id) {
		editDevice = device;
	}

	const onDetailsSaved =
		getContext<(payload: { roomChanged: boolean; roomId?: number; shared?: boolean }) => void>(
			'onDetailsSaved',
		);

	const onSave = async () => {
		if (!editDevice?.name || editDevice.name.trim() === '') return;
		requestLoader = true;
		try {
			await performDeviceEditSave(editDevice);
			devices.update(editDevice);
			onDetailsSaved?.({
				roomChanged: false,
			});
		} finally {
			requestLoader = false;
		}
	};

	$: isSaveDisabled = !editDevice?.name || editDevice.name.trim() === '' || requestLoader;

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: onSave,
				loading: requestLoader,
				disabled: isSaveDisabled,
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

<MainStep bind:editDevice />

{#if !$showNewLayout}
	<div class="mt-l">
		<Button
			class="width-sm-full"
			variant="primary"
			size="m"
			responsiveSize={{ sm: 'm' }}
			loading={requestLoader}
			disabled={isSaveDisabled}
			icon="fas fa-save"
			on:click={onSave}
		>
			{$format('button_save', { default: 'Save' })}
		</Button>
	</div>
{/if}
